import { compact, every, filter, flow, isEmpty, map, pick, some, sumBy, truncate, uniqBy, has } from 'lodash';
import { byId } from '../utils/helpers';

const SERVICE_NAMES_MAX_LENGTH = 25;

export const getServiceById = (state, id) => byId(state.services.get('items'), id);

export const getServiceDuration = (state, id) => {
  if (isEmpty(id)) return 0;

  return flow([
    ids => map(ids, item => getServiceById(state, item)),
    services => sumBy(services, service => service && service.get('duration')),
  ])(id.split(';')) || 0;
};

export const getServiceName = (state, ids) => {
  if (!ids) return '';

  return ids.split(';')
    .map(id => getServiceById(state, id))
    .reduce((acc, service) => {
      if (!service) return acc;
      if (!acc) return service.get('name');
      return `${acc}, ${service.get('name')}`;
    }, '');
};

export const getServiceNameShort = (state, ids) =>
  truncate(getServiceName(state, ids), { length: SERVICE_NAMES_MAX_LENGTH, ommission: '...' });

export const getServiceNameLong = (state, ids) => {
  const services = getServiceName(state, ids);
  if (services.length <= SERVICE_NAMES_MAX_LENGTH) return '';
  return services;
};

export const getSelectedServices = (state, ids) => (
  !isEmpty(ids) && ids.split(';')
    .map(id => getServiceById(state, id))
    .filter(service => service)
    .map(service => service.toJS())
);

export const getSelectedServicesForValidate = (state, ids) => map(
  getSelectedServices(state, ids),
  service => pick(service, ['id'])
);

const isServiceSelected = (service, ids) => ids && ids.split(';').some(id => id === service.id);
export const getServices = (state, ids) => {
  const services = state.services.get('items').toJS();
  return services.map(service => ({
    ...service,
    selected: isServiceSelected(service, ids),
  }));
};

export const getKioskServices = (state, ids) => filter(getServices(state, ids), { kioskEnabled: true });

const addUncategorizedCategory = (categories) => {
  if (isEmpty(categories)) return categories;
  return [...categories, { id: null, name: 'uncategorized' }];
};
export const getCategories = state => addUncategorizedCategory(
  compact(uniqBy(map(getServices(state), 'categories[0]'), 'id'))
);
export const getSelectedCategories = (state, ids) => {
  const categories = getCategories(state);

  return map(categories, category => ({
    ...category,
    selected: some(getSelectedServices(state, ids), { serviceCategoryId: category.id }),
  }));
};

export const getSelectedServicesPrepaid = (state, ids) =>
  every(getSelectedServices(state, ids), { requiresPrepaid: false });

export const doServicesHaveAssignments = state => has(state.services.get('items').toJS(), '[0].assignments');
export const getBarberAssignments = (state, barberId) => {
  const services = state.services.get('items').toJS();

  return services.reduce((barberAssignments, service) => {
    if (service.assignmentType === 'barber' && service.assigneeId === barberId) {
      barberAssignments.push(service);

      return barberAssignments;
    }

    const assignment = (service.assignments || []).find(a => a.assigneeId === barberId);
    if (assignment) {
      barberAssignments.push(service);
    }

    return barberAssignments;
  }, []);
};



// WEBPACK FOOTER //
// ./src/app/services/selectors.js